module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [(_vm.referralProgramId === _vm.ReferralProgram.ReferralAward) ? _c('img', {
    attrs: {
      "src": _vm.birdDog1x,
      "srcset": _vm.birdDog1x + ' 1x, ' + _vm.birdDog2x + ' 2x',
      "alt": "referral banner image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.referralProgramId === _vm.ReferralProgram.NonMonetary) ? _c('img', {
    attrs: {
      "src": _vm.nonMonetary1x,
      "srcset": _vm.nonMonetary1x + ' 1x, ' + _vm.nonMonetary2x + ' 2x',
      "alt": "referral banner image"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.referralProgramId === _vm.ReferralProgram.GiveAndGet) ? _c('img', {
    attrs: {
      "src": _vm.giveGet1x,
      "srcset": _vm.giveGet1x + ' 1x, ' + _vm.giveGet2x + ' 2x',
      "alt": "referral banner image"
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-78044218", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78044218"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/referral/referral-program-banner.vue
// module id = 851
// module chunks = 0